// extracted by mini-css-extract-plugin
export var productImage = "_xf-0";